<div>
  <h2 class="vx-section-header text-uppercase py-1 mt-0 mb-1 text-center h5">INFORMATIONAL DOWNLOADS</h2>
  <div class="row d-flex justify-content-center g-2 my-3">
    <div *ngFor="let component of nestedComponents" class="col-12 col-sm-4 docheight my-2">
      <div class="h-100">
        <ng-container [ngComponentOutlet]="component.component">
        </ng-container>
      </div>
    </div>
  </div>
</div>
